import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import DOMPurify from "dompurify";
import "./BlogDetail.css";

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [recentPosts, setRecentPosts] = useState([]);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const res = await axios.get(`http://localhost:5000/api/blogs/${id}`);
        setBlog(res.data);

        const allBlogs = await axios.get("http://localhost:5000/api/blogs");
        const recent = allBlogs.data
          .filter((b) => b._id !== res.data._id)
          .slice(0, 3);
        setRecentPosts(recent);
      } catch (err) {
        console.error("Error fetching blog:", err);
      }
    };
    fetchBlog();
  }, [id]);

  if (!blog) return <h2 className="text-center mt-5">Blog Not Found</h2>;

  return (
    <section className="blog-detail-section">
      <Helmet>
        <title>{blog.seoTitle || blog.title}</title>
        <meta
          name="description"
          content={blog.seoDescription || blog.content.substring(0, 160)}
        />
        {blog.schemaMarkup && (
          <script type="application/ld+json">{blog.schemaMarkup}</script>
        )}
      </Helmet>

      <Container>
        {/* Back Button */}
        <div className="mb-4">
          <Link to="/blog">
            <Button variant="outline-primary" className="fw-semibold back-btn">
              ← Back to Blogs
            </Button>
          </Link>
        </div>

        {/* Blog Header */}
        <h1 className="blog-title">{blog.title}</h1>

        {/* Author Info */}
        <div className="author-box mb-4">
          {blog.authorImage && (
            <img
              src={blog.authorImage}
              alt={blog.author}
              className="author-img"
            />
          )}
          <div>
            <h6 className="author-name">{blog.author}</h6>
            <small className="text-muted">
              {new Date(blog.createdAt).toLocaleDateString()}
            </small>
          </div>
        </div>

        {/* Featured Image */}
        {blog.image && (
          <div className="featured-img mb-5">
            <img
              src={`http://localhost:5000${blog.image}`}
              alt={blog.title}
              className="img-fluid rounded shadow-lg"
            />
          </div>
        )}

        {/* Categories & Tags */}
        <div className="meta-info mb-3">
          {blog.categories?.length > 0 && (
            <p>
              <strong>Categories:</strong> {blog.categories.join(", ")}
            </p>
          )}
          {blog.tags?.length > 0 && (
            <p>
              <strong>Tags:</strong> {blog.tags.join(", ")}
            </p>
          )}
        </div>

        {/* Blog Content */}
        <Row className="justify-content-center mb-5">
          <Col lg={12}>
            <div
              className="blog-content"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(blog.content, {
                  ADD_TAGS: ["table", "thead", "tbody", "tr", "th", "td"],
                  ADD_ATTR: ["style", "class"],
                }),
              }}
            ></div>

            {blog.link && (
              <p className="mt-4">
                <strong>Related Link: </strong>
                <a href={blog.link} target="_blank" rel="noopener noreferrer">
                  {blog.link}
                </a>
              </p>
            )}
            {blog.schedule && (
              <p>
                <strong>Scheduled Date:</strong>{" "}
                {new Date(blog.schedule).toLocaleString()}
              </p>
            )}
          </Col>
        </Row>

        {/* Recent Posts */}
        {recentPosts.length > 0 && (
          <>
            <h3 className="fw-bold mb-4 text-center">Recent Posts</h3>
            <Row>
              {recentPosts.map((post) => (
                <Col md={4} key={post._id} className="mb-4">
                  <Card className="recent-card">
                    <Link
                      to={`/blog/${post._id}`}
                      className="text-decoration-none text-dark"
                    >
                      {post.image && (
                        <div className="recent-img-wrapper">
                          <Card.Img
                            variant="top"
                            src={`http://localhost:5000${post.image}`}
                            alt={post.title}
                            className="recent-img"
                          />
                        </div>
                      )}
                      <Card.Body>
                        <Card.Title className="recent-title">
                          {post.title}
                        </Card.Title>
                        <small className="text-muted">
                          {new Date(post.createdAt).toLocaleDateString()}
                        </small>
                      </Card.Body>
                    </Link>
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        )}
      </Container>
    </section>
  );
};

export default BlogDetail;
